import { DocumentParameters, Source } from 'api3';
import { CommonModule, Location } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '@app/services/navigation.service';
import { HpArticlesComponent } from '@app/article/hp-articles/hp-articles.component';
import { MercedesArticlesComponent } from '@app/article/mercedes-articles/mercedes-articles.component';
import { HgsArticleComponent } from './hgs-articles/hgs-articles.component';
import { TeslaArticlesComponent } from './tesla-articles/tesla-articles.component';
import { VwArticlesComponent } from './vw-articles/vw-articles.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-article',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoPipe,
    HpArticlesComponent,
    HgsArticleComponent,
    MercedesArticlesComponent,
    VwArticlesComponent,
    TeslaArticlesComponent,
  ],
  templateUrl: './article.component.html',
  host: { class: 'print-full-height' },
})
export class ArticleComponent {
  documentParameters: (DocumentParameters & { provider?: Source['provider']; tecDocPrototypes?: string }) | undefined;
  translocoService = inject(TranslocoService);
  location = inject(Location);
  navigationService = inject(NavigationService);

  @Input() data: any;
  @Input() close: (() => void) | undefined;

  constructor(private route: ActivatedRoute) {
    this.initializeData();
  }

  goBack(): void {
    if (this.close) {
      this.close();
    }

    this.navigationService.back();
  }

  private initializeData(): void {
    this.handleDialogData(this.data);
    this.handleRouteData();
  }

  private handleDialogData(data: any): void {
    if (!data) return;

    if (Object.keys(data).length > 0) {
      this.documentParameters = data;
    }
  }

  private handleRouteData(): void {
    const queryParams = this.route.snapshot.queryParams || {};
    if (Object.keys(queryParams).length > 0) {
      this.documentParameters = queryParams as DocumentParameters;
    }
  }
}
